import React from 'react'

const Sample = () => {
    return (
        <div>Thanks</div>
    )
}

export default Sample